import { eventChannel, END } from 'redux-saga';
import {
  call, put, takeLatest, take, race, select,
} from 'redux-saga/effects';
import * as Actions from '../actions/loadingActions';
import { convertObjectKeysSnakeToCamel } from '../helpers/helper';

const API_CALL_START = 'API_CALL_START';

// takeLatestだと複数イベントが走った時にキャンセルされてしまうため、呼び出し元のsagaではtakeEveryを使う事
export function* callApi(api, ...values) {
  yield put({ type: API_CALL_START });
  try {
    yield put(Actions.setIsLoading(true));
    const response = yield call(api, ...values);
    if (response.error !== undefined) {
      throw new Error(`API: ${api.name}, ${response.error}`);
    }
    yield put(Actions.setIsLoading(false));
    yield put(Actions.setErrorMessage(null));
    return convertObjectKeysSnakeToCamel(response);
  } catch (e) {
    console.error(e);
    yield put(Actions.setIsLoading(false));
    yield put(Actions.setErrorMessage(e));
    yield put(Actions.setAlert(true));
    yield put({ type: Actions.SAGA_START_PROGRESS });
    return { success: false };
  }
}

const STOP_TIME = 6;
// progress描画単位。少なすぎても多すぎてもカクカクになる
const INTERVAL = 150;
// プログレスが先に100になるようにするための倍率。1にすると100になる前に閉じる。
const MULTIPILIER = 1.2;

function countdown(close_time) {
  return eventChannel((emitter) => {
    let secs = close_time;
    const interval = setInterval(() => {
      secs -= INTERVAL / 1000;
      if (secs >= 0) {
        emitter(secs);
      } else {
        emitter(END);
      }
    }, INTERVAL);
    return () => {
      clearInterval(interval);
    };
  });
}

export function* startCountDown(remained_time) {
  const channel = yield call(countdown, remained_time);
  try {
    while (true) {
      const seconds = yield take(channel);
      const progress = Math.round(100 - ((seconds / STOP_TIME) * 100)) * MULTIPILIER;
      yield put(Actions.setProgress(progress < 100 ? progress : 100));
    }
  } finally {
    const { pause } = yield select((state) => state.loading);
    if (!pause) {
      yield put(Actions.setProgress(100));
      yield put({ type: Actions.SAGA_CANCEL_PROGRESS });
    }
  }
}

export function* startProgress() {
  yield put(Actions.setProgress(0));
  yield race([
    startCountDown(STOP_TIME),
    take(Actions.SAGA_CANCEL_PROGRESS),
    take(Actions.SAGA_PAUSE_PROGRESS),
    take(API_CALL_START),
  ]);
}

export function* cancelProgress() {
  yield put(Actions.setPause(false));
  yield put(Actions.setAlert(false));
  yield put(Actions.setProgress(0));
  yield put(Actions.setErrorMessage(null));
}

export function* pauseProgress() {
  yield put(Actions.setPause(true));
}

export function* resumeProgress() {
  const { progress, pause } = yield select((state) => state.loading);
  if (pause) {
    yield put(Actions.setPause(false));
    yield race([
      startCountDown(STOP_TIME * ((100 - (progress * MULTIPILIER)) / 100)),
      take(Actions.SAGA_CANCEL_PROGRESS),
      take(Actions.SAGA_PAUSE_PROGRESS),
      take(API_CALL_START),
    ]);
  }
}

export default function* saga() {
  yield takeLatest(Actions.SAGA_START_PROGRESS, startProgress);
  yield takeLatest(Actions.SAGA_CANCEL_PROGRESS, cancelProgress);
  yield takeLatest(Actions.SAGA_PAUSE_PROGRESS, pauseProgress);
  yield takeLatest(Actions.SAGA_RESUME_PROGRESS, resumeProgress);
}
